import instance from '../utils/axios';

export const fetchMarketAnalysis = async () => {
    return await instance.get('/api/betting/market-analysis');
};